module.exports = __webpack_public_path__ + "img/17_3.18ea390c.png";